import React, { useCallback, useContext as useContextCore, useState } from 'react'
import type { ListField } from '@ztechapps/common.hook'
import type { FilterQuery, Template } from '@ztechapps/common.contract'
import { useTableContext } from '../Context'

export type TableFilterProviderProps = {
  field: ListField
  children: React.ReactNode
}
export type TableFilterProps = Omit<TableFilterProviderProps, 'children'>

export type OnFilterFunction = (extraFilter: FilterQuery<any>) => void
export type ContextType = {
  showFilterContainer: boolean
  setShowFilterContainer: React.Dispatch<React.SetStateAction<boolean>>
  onFilter: OnFilterFunction
  getStoredFilter: () => FilterQuery<any>
  hasFilterValue: () => boolean
} & Omit<TableFilterProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const TableFilterProvider = ({ children, field, ...props }: TableFilterProviderProps) => {
  const [showFilterContainer, setShowFilterContainer] = useState(false)
  const { listResult, hasFilterValue: hasFilterValueCore, getStoredFilter: getStoredFilterCore } = useTableContext()
  const fieldName = field.name

  const getStoredFilter = useCallback(() => {
    return getStoredFilterCore(fieldName)
  }, [getStoredFilterCore, fieldName])

  const hasFilterValue = (): boolean => {
    return hasFilterValueCore(fieldName)
  }

  const onFilter: OnFilterFunction = (tableFilter: FilterQuery<any>) => {
    const currentTemplate = (listResult?.filterTemplate ?? {}) as Template

    const template = {
      ...currentTemplate,
      name: 'Field filter',
    }
    listResult.onFilter({ template, tableFilter })
  }

  return (
    <CoreProvider value={{ ...props, onFilter, field, showFilterContainer, setShowFilterContainer, getStoredFilter, hasFilterValue }}>
      {children}
    </CoreProvider>
  )
}

export const useTableFilterContext = () => useContextCore(context)
